import React from 'react'
import './Instruction.css'
import '../Palette/Palette.css'

const Instruction = (props) => {
    return (
        <article
            className="instruction"
            dangerouslySetInnerHTML={{ __html: props.data }}
        ></article>
    )
}

export default Instruction
